// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XvOj","question":"styles_question__1LWfA","description":"styles_description__1EStD"};